<template>
  <div class="service">
    <welcome/>
    <itemServices v-for="item in items" v-bind:key="item.title" :data="item" :id="item.id"/>
  </div>
</template>

<script>
import itemServices from "../components/Servicios/item";
import welcome from "../components/Home/welcome";
export default {
  components: {
    itemServices,
    welcome
  },
  data() {
    return {
      items: [
        {
          id: 0,
          title: "DESARROLLO WEB",
          img: require("../assets/webDev.svg"),
          content: `Las empresas que no aprovechan las herramientas tecnológicas no
            tienen futuro, en Overlab desarrollamos todas las herramientas que
            su organización necesita para mejorar sus procesos y optimizar los
            tiempos de producción y tiempos de respuesta, entre los sistemas que
            desarrollamos tenemos:`,
          list: [
            "Trámites y servicios en línea.",
            "Sistemas de Gestión Educativa.",
            "Sistemas de planificación de recursos.",
            "Sistema de Administración de clientes.",
          ],
        },
        {
          id: 1,
          title: "APLICACIONES MÓVILES",
          img: require("../assets/MobilDev.svg"),
          content: `En el mundo existen más de 5 billones de usuarios de dispositivos móviles, el
           contacto con los usuarios a través de uno de estos dispositivos es inmediato,
            por eso nos centramos en desarrollar aplicaciones que agreguen valor
             mediante el estudio de las necesidades reales de su organización, con
              estrategias que maximicen la productivas de empleados y usuarios.`,
          list: ["Multiplataforma.", "Aplicaciones con Georreferenciación."],
        },
        {
          id: 2,
          title: "GAMIFICACIÓN",
          img: require("../assets/gamin.svg"),
          content: `En Overlab acompañamos a su organización en la ideación, desarrollo e implementación de herramientas para mejorar la comunicación en procesos de capacitación, que aprovechan el uso de videojuegos, realidad virtual y realidad aumentada, generando interactividad e inclusión en el proceso.`,
          list: [
            "Videojuegos educativos.",
            "Aplicaciones en Realidad Aumentada.",
            "Aplicaciones en Realidad Virtual.",
          ],
        },
        {
          id: 3,
          title: "COMERCIALIZACIÓN DE EQUIPOS DE COMPUTO",
          img: require("../assets/computo.svg"),
          content: `Las empresas que no aprovechan las herramientas tecnológicas no tienen futuro, en Overlab cuenta con una amplia variedad de sistemas de cómputo y accesorios, destinados a la satisfacción de las necesidades de las organizaciones que desean la adquisición de equipos a bajo costo y con amplia garantía.`,
          list: ["Equipos de computo.", "Infraestructura computacional."],
        },
      ],
    };
  },
  created(){
    document.title = "OverLab | Nuestros servicios"
  }
};
</script>

<style lang="css" scoped>
.service {
  margin-top: 100px;
}
.imgBox {
  text-align: center;
}
.imgBox h1 {
  text-align: left;
  color: var(--primary);
  border-bottom: 2px solid var(--primary);
}
.imgBox img {
  height: 50vh;
}
.txtBox {
  padding: 50px;
  margin: 0 auto;
}
@media (max-width: 995px) {
  .service {
    margin-top: 0;
  }
}
</style>
